import PropTypes from 'prop-types';

const AuthPaymentMethodType = PropTypes.shape({
  id: PropTypes.string,
  display_name: PropTypes.string,
  external_id: PropTypes.string,
  status: PropTypes.string,
  payment_method: PropTypes.string
});

const AuthPaymentAccountType = PropTypes.shape({
  id: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  display_name: PropTypes.string,
  processor: PropTypes.string,
  external_id: PropTypes.string,
  status: PropTypes.string,
  auth_payment_methods: PropTypes.arrayOf(AuthPaymentMethodType)
});

export default AuthPaymentAccountType;
